/**
 * Kept separate from ColourPalette, which has too few distinct hues dark enough for white initials
 * (WCAG AA); switch to a core-ui organisation palette if design adds one.
 */
export const ORGANISATION_COLOURS = [
    "#1E6FD9",
    "#7B3FD1",
    "#C2185B",
    "#00796B",
    "#B45309",
    "#2E7D32",
    "#5C6BC0",
    "#455A64",
] as const;

/**
 * Gets a colour for an organisation that is distinct from the user's other organisations
 * while the palette lasts.
 * @param shortcode The organisation's shortcode.
 * @param shortcodes All shortcodes available to the user.
 * @returns A hex colour.
 */
export const getOrganisationColour = (
    shortcode: string,
    shortcodes: string[],
): string => {
    const index = Math.max([...shortcodes].sort().indexOf(shortcode), 0);
    return ORGANISATION_COLOURS[index % ORGANISATION_COLOURS.length];
};

export const getOrganisationInitials = (name: string): string =>
    name
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0].toUpperCase())
        .join("");
